import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GhostComponent } from './ghost.component';

@NgModule({
    declarations: [GhostComponent],
    imports: [ CommonModule ],
    exports: [GhostComponent],
    providers: [],
})
export class GhostModule {}
